import { useState, useEffect } from 'react';
import { doc, onSnapshot, updateDoc, arrayUnion, getDoc, setDoc } from 'firebase/firestore';
import { firestore } from './firebase';
import { sendEmailViaHeroku } from './emailService';

// if hello@titledworks.com dont send email

export function useThreadMessages(itemId, userEmail, currentUserEmail, itemTitle) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Create thread ID: itemId_userEmail
  const threadId = itemId && userEmail ? `${itemId}_${userEmail}` : null;

  useEffect(() => {
    if (!threadId) {
      setMessages([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    // Listen to the thread document for real-time updates
    const threadRef = doc(firestore, 'offers', threadId);
    const unsubscribe = onSnapshot(
      threadRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setMessages(data.messages || []);
        } else {
          setMessages([]);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to thread:', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [threadId]);

  const sendMessage = async (messageText, sendEmail = false) => {
    console.log('sendMessage', messageText, sendEmail);
    console.log('threadId', threadId);
    console.log('userEmail', userEmail);
    console.log('currentUserEmail', currentUserEmail);
    if (!threadId || !messageText.trim()) return;

    const newMessage = {
      message: messageText.trim(),
      user: currentUserEmail,
      timestamp: new Date()
    };

    try {
      const threadRef = doc(firestore, 'offers', threadId);
      
      // Check if thread exists
      const threadDoc = await getDoc(threadRef);
      
      if (threadDoc.exists()) {
        // Thread exists, append to messages array
        await updateDoc(threadRef, {
          messages: arrayUnion(newMessage)
        });
      } else {
        // Thread doesn't exist, create it with first message
        await setDoc(threadRef, {
          itemId,
          userEmail,
          messages: [newMessage],
          createdAt: new Date()
        }); 
      }

      // Send email notification if requested
      if (sendEmail && userEmail) {
        try {
          await sendEmailViaHeroku({
            message: `\n"${messageText.trim()}"\n\n<a href="https://titledworks.com/item/${itemId}">${itemTitle}</a>`,
            user: userEmail,
            recipient: 'hello@titledworks.com',
            itemId: itemId
          });
        } catch (emailError) {
          console.error('Email notification failed:', emailError);
          // Don't fail the message send if email fails
        }
      }

      // Remove optimistic update - let onSnapshot handle it
      // setMessages(prev => [...prev, newMessage]);
      
      return true;
    } catch (err) {
      console.error('Error sending message:', err);
      setError(err);
      return false;
    }
  };

  const markMessagesAsSeen = async () => {
    if (!threadId) return;

    try {
      const threadRef = doc(firestore, 'offers', threadId);
      const threadDoc = await getDoc(threadRef);
      
      if (threadDoc.exists()) {
        const threadData = threadDoc.data();
        const existingMessages = threadData.messages || [];
        
        // Check if any titledworks messages need to be marked as seen
        const hasUnseenTitledworksMessages = existingMessages.some(msg => 
          msg.user === 'hello@titledworks.com' && !msg.seenByUser
        );
        
        if (hasUnseenTitledworksMessages) {
          // Mark all titledworks messages as seen by user
          const updatedMessages = existingMessages.map(msg => {
            if (msg.user === 'hello@titledworks.com') {
              return {
                ...msg,
                seenByUser: true
              };
            }
            return msg;
          });
          
          await updateDoc(threadRef, {
            messages: updatedMessages
          });
          
          console.log('Marked titledworks messages as seen by user (on thread open)');
        }
      }
    } catch (err) {
      console.error('Error marking messages as seen:', err);
    }
  };

  return {
    messages,
    loading,
    error,
    sendMessage,
    markMessagesAsSeen
  };
} 